import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MAPDIST } from 'src/app/shared/config';
import { UtilsService } from 'src/app/shared/services';

@Component({
  selector: 'app-214_rgznwindow',
  templateUrl: './214_rgznwindow.component.html',
  styleUrls: ['./214_rgznwindow.component.styl']
})
export class NewrgznwindowComponent implements OnInit {
  ttitle = '';

  data: any = [];
  rows: any = [];

  typei = 1;
  types: string[] = ['', ''];

  constructor(
    private util: UtilsService,
    private http: HttpClient,
    private router: Router  ) { }
    
  ngOnInit() {

    this.ttitle = MAPDIST.science_rgzn.title;
    this.http.get(MAPDIST.science_rgzn.api).toPromise().then((rows: any) => {
      this.data = rows;
/*const test = [{"id":1,"name":"上海市黄浦区卢湾一中心小学","pc":"第一批","type":"同学段发展共同体","superior":"黄浦区","address":"上海市黄浦区淡水路450号","location":"31.211812,121.473683","org_id":"396"},{"id":2,"name":"上海市嘉定区卢湾一中心实验小学","pc":"第一批","type":"同学段发展共同体","superior":"嘉定区","address":"上海市嘉定区江桥镇海波路969号","location":"31.268962,121.328801","org_id":"464"},{"id":3,"name":"上海商学院","pc":"第一批","type":"本科高校","superior":"市教委","address":"奉贤区奉浦大道123号、上海市中山西路2271号","location":"30.940794,121.456439","org_id":"90"},{"id":4,"name":"上海音乐学院","pc":"第一批","type":"本科高校","superior":"市教委","address":"上海市徐汇区汾阳路20号","location":"31.213492,121.454506","org_id":"4192"},{"id":5,"name":"上海交通大学","pc":"第一批","type":"本科高校","superior":"教育部","address":"上海市闵行区东川路800号","location":"31.025687,121.436891","org_id":"31"},{"id":6,"name":"上海市实验学校","pc":"第一批","type":"十年一贯制","superior":"市教委","address":"中学部：上海市浦东新区东明路300号 国际部：上海市徐汇区田林十三村1号","location":"31.182762,121.508745","org_id":"1017"},{"id":7,"name":"上海市建平中学","pc":"第一批","type":"跨学段发展共同体","superior":"浦东新区","address":"上海市浦东新区崮山路517号、上海市浦东新区崮山路385号（北校区）","location":"31.243516,121.558920","org_id":"1207"},{"id":8,"name":"上海市吴淞中学","pc":"第一批","type":"跨学段发展共同体","superior":"宝山区","address":"上海市宝山区泰和路99号","location":"31.376419,121.497043","org_id":"428"},{"id":9,"name":"上海市徐汇区科技幼儿园","pc":"第一批","type":"幼儿园","superior":"徐汇区","address":"徐汇区嘉陵路28号、徐汇区宜山路655弄1号、徐汇区宜山路655弄10号","location":"31.149295,121.428997","org_id":"1333"},{"id":10,"name":"上海市静安区安庆幼儿园","pc":"第一批","type":"幼儿园","superior":"静安区","address":"上海市静安区三泉路517弄46号、上海市静安区平顺路71号","location":"31.309066,121.439572","org_id":"3322"},{"id":11,"name":"上海中医药大学附属闵行蔷薇小学","pc":"第一批","type":"小学","superior":"闵行区","address":"上海市闵行区春申路1581弄5号","location":"31.114671,121.433508","org_id":"4482"},{"id":12,"name":"上海市第一师范学校附属小学","pc":"第一批","type":"小学","superior":"静安区","address":"上海市静安区桂林西街14弄25号","location":"31.155821,121.418000","org_id":"2600"},{"id":13,"name":"上海市奉贤区明德外国语小学","pc":"第一批","type":"小学","superior":"奉贤区","address":"上海市奉贤区大型居住社区褚家路176号","location":"30.924736,121.520097","org_id":"706"},{"id":14,"name":"上海市闸北第八中学","pc":"第一批","type":"完中","superior":"静安区","address":"上海市静安区场中路2950弄80号","location":"31.301409,121.436721","org_id":"3145"},{"id":15,"name":"上海市进才中学北校","pc":"第一批","type":"初中","superior":"浦东新区","address":"羽山路校区：浦东新区羽山路601号、苗圃路校区：浦东新区苗圃路555号","location":"31.234215,121.546450","org_id":"2792"},{"id":16,"name":"上海市上海中学","pc":"第一批","type":"高中","superior":"市教委","address":"上海市徐汇区百色路989号、上海市徐汇区上中路400号","location":"31.139370,121.435990","org_id":"275"},{"id":17,"name":"同济大学第一附属中学","pc":"第一批","type":"高中","superior":"杨浦区","address":"上海市杨浦区国浩路100号","location":"31.336944,121.518471","org_id":"4268"},{"id":18,"name":"上海市晋元高级中学","pc":"第一批","type":"高中","superior":"普陀区","address":"上海市普陀区新村路2169号","location":"31.269900,121.396781","org_id":"1423"},{"id":19,"name":"上海信息技术学校","pc":"第一批","type":"中职","superior":"上海华谊（集团）公司","address":"上海普陀区真南路1008号","location":"31.272386,121.379801","org_id":"56"},{"id":20,"name":"上海市经济管理学校","pc":"第一批","type":"中职","superior":"市教委","address":"上海市普陀区澳门路726号","location":"31.243085,121.434877","org_id":"2631"},{"id":21,"name":"复旦大学","pc":"第一批","type":"本科高校","superior":"教育部","address":"上海市杨浦区邯郸路220号","location":"31.296795,121.503359","org_id":"4276"},{"id":22,"name":"华东师范大学","pc":"第一批","type":"本科高校","superior":"教育部","address":"上海市东川路500号、上海市中山北路3663号","location":"31.227006,121.405958","org_id":"4221"},{"id":23,"name":"上海中医药大学","pc":"第一批","type":"本科高校","superior":"市教委","address":"上海市浦东新区蔡伦路1200号","location":"31.194048,121.596754","org_id":"16"},{"id":24,"name":"上海开放大学","pc":"第一批","type":"本科高校","superior":"市教委","address":"上海市国顺路288号","location":"31.293241,121.514150","org_id":"3552"},{"id":25,"name":"上海市静安区教育学院附属学校","pc":"第二批","type":"九年一贯制","superior":"静安区","address":"小学部：上海市静安区江宁路688号、中学部：上海市静安区海防路374号","location":"31.237951,121.449393","org_id":"3355"},{"id":26,"name":"华东师范大学第二附属中学附属初级中学","pc":"第二批","type":"跨学段发展共同体","superior":"闵行区/高校直属","address":"上海市闵行区紫凤路350号","location":"31.031198,121.462420","org_id":"4232"},{"id":27,"name":"上海市格致中学","pc":"第二批","type":"跨学段发展共同体","superior":"黄浦区","address":"黄浦本部：上海市黄浦区广西北路66号（北海路150号）","location":"31.231009,121.479988","org_id":"1838"},{"id":28,"name":"复旦大学第二附属中学","pc":"第二批","type":"九年一贯制","superior":"高校直属","address":"上海市杨浦区政修路215号","location":"31.290617,121.504596","org_id":"4281"},{"id":29,"name":"上海外国语大学松江外国语学校","pc":"第二批","type":"九年一贯制","superior":"松江区","address":"上海市松江区方松街道梅家浜路1701号","location":"31.052682,121.222911","org_id":"110"},{"id":30,"name":"上海市风华初级中学","pc":"第二批","type":"同学段发展共同体","superior":"静安区","address":"上海市永和东路393号","location":"31.291952,121.458939","org_id":"3427"},{"id":31,"name":"上海市浦东新区第二中心小学","pc":"第二批","type":"小学","superior":"浦东新区","address":"上海市浦东新区巨野路517号","location":"31.235948,121.549448","org_id":"2395"},{"id":32,"name":"上海市嘉定区安亭小学","pc":"第二批","type":"小学","superior":"嘉定区","address":"上海市嘉定区新源路828号","location":"31.302362,121.153510","org_id":"484"},{"id":33,"name":"上海市宝山区宝虹小学","pc":"第二批","type":"小学","superior":"宝山区","address":"上海市宝山区菊盛路150号","location":"31.350878,121.372989","org_id":"841"},{"id":34,"name":"上海市长宁区天山第一小学","pc":"第二批","type":"小学","superior":"长宁区","address":"上海市长宁区茅台路109号","location":"31.208981,121.404733","org_id":"2931"},{"id":35,"name":"上海市普陀区曹杨实验小学","pc":"第二批","type":"小学","superior":"普陀区","address":"上海市普陀区万镇路838号","location":"31.248405,121.378116","org_id":"1474"},{"id":36,"name":"上海市实验小学","pc":"第二批","type":"小学","superior":"黄浦区","address":"上海老城厢露香园路242号","location":"31.223708,121.485793","org_id":"4507"},{"id":37,"name":"上海市徐汇区高安路第一小学","pc":"第二批","type":"小学","superior":"徐汇区","address":"上海市徐汇区康平路4弄9号（四年级~五年级）、上海市徐汇区宛平路231号 （一年级~三年级）","location":"31.199494,121.443955","org_id":"1363"},{"id":38,"name":"上海市杨浦区六一小学","pc":"第二批","type":"小学","superior":"杨浦区","address":"上海市杨浦区政通路25号","location":"31.305170,121.521937","org_id":"1597"},{"id":39,"name":"上海市徐汇区教育学院附属实验中学","pc":"第二批","type":"初中","superior":"徐汇区","address":"上海市徐汇区上中路50号（从老沪闵路上的门口进）","location":"31.137630,121.432761","org_id":"1279"},{"id":40,"name":"上海市教育学会宝山实验学校","pc":"第二批","type":"九年一贯制","superior":"宝山区","address":"上海市宝山区高境路371号","location":"31.322443,121.473687","org_id":"1392"},{"id":41,"name":"上海市洋泾菊园实验学校","pc":"第二批","type":"九年一贯制","superior":"浦东新区","address":"上海市洋泾菊园实验学校","location":"31.228056,121.511477","org_id":"1922"},{"id":42,"name":"上海市仙霞高级中学","pc":"第二批","type":"完中","superior":"长宁区","address":"上海市长宁区水城路450弄","location":"31.208299,121.392943","org_id":"316"},{"id":43,"name":"上海市大同中学","pc":"第二批","type":"高中","superior":"黄浦区","address":"上海市南车站路353号","location":"31.206761,121.492850","org_id":"653"},{"id":44,"name":"华东理工大学附属闵行科技高级中学","pc":"第二批","type":"高中","superior":"闵行区","address":"上海市闵行区银康路820号","location":"31.019980,121.372030","org_id":"4261"},{"id":45,"name":"上海市复兴高级中学","pc":"第二批","type":"高中","superior":"虹口区","address":"上海市虹口区车站南路28号","location":"31.294862,121.482081","org_id":"641"},{"id":46,"name":"上海市朱家角中学","pc":"第二批","type":"高中","superior":"青浦区","address":"上海市青浦区沙家埭路88号","location":"31.104086,121.042894","org_id":"1573"},{"id":47,"name":"上海市金山中学","pc":"第二批","type":"高中","superior":"金山区","address":"上海市金山区众益街899号","location":"30.881621,121.160890","org_id":"2802"},{"id":48,"name":"上海市延安中学","pc":"第二批","type":"高中","superior":"长宁区","address":"上海市长宁区茅台路1111号","location":"31.209790,121.379880","org_id":"1201"},{"id":49,"name":"上海市崇明中学","pc":"第二批","type":"高中","superior":"崇明区","address":"上海市崇明区鼓浪屿路801号","location":"31.640405,121.416437","org_id":"1031"},{"id":50,"name":"上海市市二中学","pc":"第二批","type":"高中","superior":"徐汇区","address":"上海市徐汇区永康路200号","location":"31.210547,121.455239","org_id":"2606"},{"id":51,"name":"上海石化工业学校","pc":"第二批","type":"中职","superior":"金山区","address":"上海市金山区龙胜路1097号","location":"30.720883,121.326158","org_id":"3962"},{"id":52,"name":"上海市贸易学校","pc":"第二批","type":"中职","superior":"光明集团","address":"上海市普陀区云岭西路689弄170号","location":"31.227764,121.364218","org_id":"2787"},{"id":53,"name":"上海市西南工程学校","pc":"第二批","type":"中职","superior":"闵行区","address":"上海市闵行区都会路3552号   ","location":"31.084012,121.411553","org_id":"2779"},{"id":54,"name":"上海市杨浦职业技术学校","pc":"第二批","type":"中职","superior":"杨浦区","address":"上海市杨浦区凤城路50号","location":"31.277459,121.524063","org_id":"1716"},{"id":55,"name":"上海市奉贤中等专业学校","pc":"第二批","type":"中职","superior":"奉贤区","address":"上海市奉贤区八字桥路626号","location":"30.937391,121.459580","org_id":"665"},{"id":56,"name":"上海建桥学院","pc":"第二批","type":"本科高校","superior":"民办","address":"上海市浦东新区南汇新城沪城环路1111号","location":"30.891181,121.892755","org_id":"3550"},{"id":57,"name":"上海思博职业技术学院","pc":"第二批","type":"高职高专","superior":"民办","address":"上海市浦东新区城南路1408号","location":"31.037626,121.780648","org_id":"3588"},{"id":58,"name":"上海市第三女子中学","pc":"第三批","type":"跨学段发展共同体","superior":"","address":"长宁区江苏路155号","location":"31.22245,121.42995","org_id":"2604"},{"id":59,"name":"上海市南洋模范中学","pc":"第三批","type":"跨学段发展共同体","superior":"","address":"徐汇区零陵路453号","location":"31.18975,121.45166","org_id":"382"},{"id":60,"name":"上海市行知中学","pc":"第三批","type":"跨学段发展共同体","superior":"","address":"宝山区子青路99号","location":"31.40575,121.49675","org_id":"2772"},{"id":61,"name":"上海市青浦区实验小学","pc":"第三批","type":"跨学段发展共同体","superior":"","address":"青浦区城中西路25号（城中校区）、青浦区青湖路459号（青湖校区）、青浦区海盈路1518号（御澜湾校区）","location":"31.147322,121.117683","org_id":"3178"},{"id":62,"name":"上海市建青实验学校","pc":"第三批","type":"十五年一贯制","superior":"","address":"长宁区古羊路900号","location":"31.19194,121.40093","org_id":"1218"},{"id":63,"name":"上海音乐学院实验学校","pc":"第三批","type":"九年一贯制","superior":"","address":"杨浦区政和路359号","location":"31.32798,121.5123","org_id":"4194"},{"id":64,"name":"上海外国语大学嘉定外国语学校","pc":"第三批","type":"九年一贯制","superior":"","address":"嘉定区安亭镇墨玉北路888号","location":"31.32617,121.16385","org_id":"106"},{"id":65,"name":"上海科技大学附属民办学校","pc":"第三批","type":"九年一贯制","superior":"","address":"浦东新区盛荣路600号","location":"31.16438,121.60973","org_id":"6847"},{"id":66,"name":"上海市莘城学校","pc":"第三批","type":"九年一贯制","superior":"","address":"闵行区普洱路158号","location":"31.09958,121.39021","org_id":"2668"},{"id":67,"name":"上海市浦东新区西门幼儿园","pc":"第三批","type":"幼儿园","superior":"","address":"浦东新区妙川路299号","location":"31.17662,121.69768","org_id":"2455"},{"id":68,"name":"上海市杨浦区本溪路幼儿园","pc":"第三批","type":"幼儿园","superior":"","address":"杨浦区双辽路375号（伊东部）、杨浦区本溪路146号（本溪部）、杨浦区政悦路258号（政悦部）、杨浦区清流环二路100号（政蓝部）","location":"31.272329,121.512688","org_id":"1668"},{"id":69,"name":"上海市金山区朱泾罗星幼儿园","pc":"第三批","type":"幼儿园","superior":"","address":"金山区金龙新街1088号（金龙部）、金山区新安街80号（新安部）","location":"30.88615,121.15711","org_id":"2853"},{"id":70,"name":"上海市宝山区七色花艺术幼儿园","pc":"第三批","type":"幼儿园","superior":"","address":"宝山区宝山八村78号和87号（宝山园）、宝山区宝林路336号（宝林园）","location":"31.417419,121.343361","org_id":"791"},{"id":71,"name":"上海市闵行区爱博果果幼儿园","pc":"第三批","type":"幼儿园","superior":"","address":"闵行区天山西路4350号","location":"31.21216,121.30623","org_id":"3074"},{"id":72,"name":"上海市盲童学校","pc":"第三批","type":"特殊教育","superior":"","address":"长宁区虹桥路1850号","location":"31.19797,121.38875","org_id":"2592"},{"id":73,"name":"上海市闵行区田园外语实验小学","pc":"第三批","type":"小学","superior":"","address":"闵行区都市路3000号（金都校区）、闵行区都市路4388号（银都校区）","location":"31.07527,121.40418","org_id":"3076"},{"id":74,"name":"上海戏剧学院附属新世界实验小学","pc":"第三批","type":"小学","superior":"","address":"浦东新区云台路230号（昌里校区）、浦东新区洪山路753号（洪山校区）","location":"31.177214,121.516182","org_id":"2238"},{"id":75,"name":"上海市普陀区武宁路小学","pc":"第三批","type":"小学","superior":"","address":"普陀区东新路340号","location":"31.24009,121.424","org_id":"1493"},{"id":76,"name":"上海市宝山区实验小学","pc":"第三批","type":"小学","superior":"","address":"宝山区东林路500号（东林校区）、宝山区团结路29号(西校区)","location":"31.41162,121.49052","org_id":"843"},{"id":77,"name":"上海市嘉定区实验小学","pc":"第三批","type":"小学","superior":"","address":"嘉定区平城路625号","location":"31.3988,121.25226","org_id":"489"},{"id":78,"name":"上海市浦东新区孙桥小学","pc":"第三批","type":"小学","superior":"","address":"浦东新区孙宇路289号(申江校区）、浦东新区张江路1615号（张江校区）、浦东新区三灶路951号（雪英校区）","location":"31.178444,121.629616","org_id":"2152"},{"id":79,"name":"上海外国语大学附属外国语学校","pc":"第三批","type":"完中","superior":"","address":"虹口区中山北一路295号","location":"31.27829,121.48049","org_id":"120"},{"id":80,"name":"上海市徐汇中学","pc":"第三批","type":"完中","superior":"","address":"徐汇区虹桥路68号（本部）、徐汇区广元西路187号（北校区）、徐汇区华发路68号（南校区）","location":"31.19313,121.43577","org_id":"1227"},{"id":81,"name":"上海市延安初级中学","pc":"第三批","type":"初中","superior":"","address":"长宁区延安西路601号（延安西路校区）、长宁区长宁路1302弄9号（长宁路校区）","location":"31.21561,121.43563","org_id":"1202"},{"id":82,"name":"上海市江湾初级中学","pc":"第三批","type":"初中","superior":"","address":"虹口区奎照路528弄16号","location":"31.29984,121.47477","org_id":"1911"},{"id":83,"name":"上海市育才初级中学","pc":"第三批","type":"初中","superior":"","address":"静安区山海关路445号","location":"31.23486,121.46139","org_id":"2651"},{"id":84,"name":"上海市奉贤区汇贤中学","pc":"第三批","type":"初中","superior":"","address":"奉贤区运河路288号","location":"30.92245,121.46828","org_id":"4303"},{"id":85,"name":"复旦大学附属中学","pc":"第三批","type":"高中","superior":"","address":"杨浦区国权路383号","location":"31.29108,121.50621","org_id":"646"},{"id":86,"name":"上海师范大学附属中学","pc":"第三批","type":"高中","superior":"","address":"浦东新区浦星公路388号（本部）、闵行区浦佳路91号（闵行分校）","location":"31.124,121.49298","org_id":"3523"},{"id":87,"name":"上海市控江中学","pc":"第三批","type":"高中","superior":"","address":"杨浦区双阳路388号","location":"31.2796,121.5333","org_id":"1389"},{"id":88,"name":"上海市曹杨第二中学","pc":"第三批","type":"高中","superior":"","address":"普陀区梅川路160号","location":"31.23892,121.40071","org_id":"1566"},{"id":89,"name":"上海市卢湾高级中学","pc":"第三批","type":"高中","superior":"","address":"黄浦区斜土路885号","location":"31.2017,121.46922","org_id":"402"},{"id":90,"name":"上海市嘉定区第一中学","pc":"第三批","type":"高中","superior":"","address":"嘉定区嘉行公路701号","location":"31.40645,121.2545","org_id":"564"},{"id":91,"name":"上海市松江二中","pc":"第三批","type":"高中","superior":"","address":"松江区中山东路250号","location":"31.00937,121.24333","org_id":"1720"},{"id":92,"name":"上海海事大学附属北蔡高级中学","pc":"第三批","type":"高中","superior":"","address":"浦东新区莲园路246号","location":"31.185,121.55276","org_id":"3916"},{"id":93,"name":"上海交通大学附属中学嘉定分校","pc":"第三批","type":"高中","superior":"","address":"嘉定区云谷路1660号","location":"31.35249,121.24416","org_id":"38"},{"id":94,"name":"上海市工业技术学校","pc":"第三批","type":"中职","superior":"","address":"徐汇区喜泰支路8号","location":"31.14631,121.45341","org_id":"1163"},{"id":95,"name":"上海商业会计学校","pc":"第三批","type":"中职","superior":"","address":"黄浦区陆家浜路918号（黄浦校区）、普陀区交通路1933号（普陀校区）","location":"31.21226,121.49093","org_id":"87"},{"id":96,"name":"江南造船集团职业技术学校","pc":"第三批","type":"中职","superior":"","address":"长兴岛潘圆公路447号甲","location":"31.38943,121.69383","org_id":"4376"},{"id":97,"name":"上海市现代音乐职业学校","pc":"第三批","type":"中职","superior":"","address":"杨浦区本溪路118号","location":"31.27746,121.51999","org_id":"2579"},{"id":98,"name":"上海市城市科技学校","pc":"第三批","type":"中职","superior":"","address":"松江区人民北路925号","location":"31.02307,121.22373","org_id":"635"},{"id":99,"name":"上海工商信息学校","pc":"第三批","type":"中职","superior":"","address":"青浦区公园东路2025号","location":"31.15174,121.13107","org_id":"236"},{"id":100,"name":"上海市材料工程学校","pc":"第三批","type":"中职","superior":"","address":"徐汇区罗秀路136号","location":"31.130281,121.446809","org_id":"1576"},{"id":101,"name":"上海市商业学校","pc":"第三批","type":"中职","superior":"","address":"静安区共和新路1458号","location":"31.26626,121.45838","org_id":"439"},{"id":102,"name":"上海南湖职业技术学院","pc":"第三批","type":"高职高专","superior":"","address":"虹口区三门路661号","location":"31.31181,121.48407","org_id":"75"},{"id":103,"name":"同济大学","pc":"第三批","type":"本科高校","superior":"","address":"杨浦区四平路1239号（四平校区）、普陀区真南路500号（沪西校区）、普陀区中山北路727号（沪北校区）、嘉定区曹安公路4800号（嘉定校区）","location":"31.28258,121.50616","org_id":"4264"},{"id":104,"name":"上海大学","pc":"第三批","type":"本科高校","superior":"","address":"宝山区上大路99号（宝山校区）、静安区延长路149号（延长校区）、嘉定区城中路20号（嘉定校区）","location":"31.31911,121.394","org_id":"128"},{"id":105,"name":"上海对外经贸大学","pc":"第三批","type":"本科高校","superior":"","address":"长宁区古北路620号（长宁校区）、松江区文翔路1900号（松江校区）、闵行区漕宝路3349号（闵行校区）","location":"31.20695,121.4002","org_id":"224"},{"id":106,"name":"上海立信会计金融学院","pc":"第三批","type":"本科高校","superior":"","address":"松江区文翔路2800号（松江校区）、浦东新区上川路995号（浦东校区）、徐汇区中山西路2230号（徐汇校区）","location":"31.04364,121.19889","org_id":"6812"},{"id":107,"name":"华东理工大学","pc":"第三批","type":"本科高校","superior":"","address":"徐汇区梅陇路130号（徐汇校区）、奉贤区海思路999号（奉贤校区）、金山区学府路1000号（金山校区）","location":"31.1412,121.4257","org_id":"6853"},{"id":108,"name":"上海交通大学医学院","pc":"第三批","type":"本科高校","superior":"","address":"黄浦区重庆南路227号","location":"31.21254,121.47136","org_id":"29"},{"id":109,"name":"上海海事大学","pc":"第三批","type":"本科高校","superior":"","address":"浦东新区海港大道1550号（临港校区）、浦东新区浦东大道2600号（港湾校区）、上海市浦东大道1608号","location":"30.87102,121.909","org_id":"3913"},{"id":110,"name":"上海财经大学","pc":"第三批","type":"本科高校","superior":"","address":"杨浦区国定路777号（主校区）、上海市虹口区中山北一路369号、虹口区昆山路146号","location":"31.30584,121.50404","org_id":"4004"},{"id":111,"name":"上海老年大学","pc":"第三批","type":"其他","superior":"","address":"黄浦区南塘浜路117号、徐汇区钦州南路500号（钦州书院）","location":"31.20348,121.47295","org_id":"4516"},{
    "id": 112,
    "org_id": "",
    "name": "上海理工大学",
    "pc": "第四批",
    "superior": "",
    "type": "本科高校",
    "address": "",
    "location": ""
  },
  {
    "id": 113,
    "org_id": "",
    "name": "上海师范大学",
    "pc": "第四批",
    "superior": "",
    "type": "本科高校",
    "address": "",
    "location": ""
  },
  {
    "id": 114,
    "org_id": "",
    "name": "上海工程技术大学",
    "pc": "第四批",
    "superior": "",
    "type": "本科高校",
    "address": "",
    "location": ""
  },
  {
    "id": 115,
    "org_id": "",
    "name": "上海科技大学",
    "pc": "第四批",
    "superior": "",
    "type": "本科高校",
    "address": "",
    "location": ""
  },
  {
    "id": 116,
    "org_id": "",
    "name": "上海电机学院",
    "pc": "第四批",
    "superior": "",
    "type": "本科高校",
    "address": "",
    "location": ""
  },
  {
    "id": 117,
    "org_id": "",
    "name": "上海健康医学院",
    "pc": "第四批",
    "superior": "",
    "type": "本科高校",
    "address": "",
    "location": ""
  },
  {
    "id": 118,
    "org_id": "",
    "name": "上海戏剧学院",
    "pc": "第四批",
    "superior": "",
    "type": "本科高校",
    "address": "",
    "location": ""
  },
  {
    "id": 119,
    "org_id": "",
    "name": "上海工艺美术职业学院",
    "pc": "第四批",
    "superior": "",
    "type": "高职高专",
    "address": "",
    "location": ""
  },
  {
    "id": 120,
    "org_id": "",
    "name": "上海建设管理职业技术学院",
    "pc": "第四批",
    "superior": "",
    "type": "高职高专",
    "address": "",
    "location": ""
  },
  {
    "id": 121,
    "org_id": "6122",
    "name": "上海科学技术职业学院",
    "pc": "第四批",
    "superior": "嘉定区",
    "type": "高职高专",
    "address": "金沙路280号",
    "location": "31.3873,121.258181"
  },
  {
    "id": 122,
    "org_id": "",
    "name": "上海交通职业技术学院",
    "pc": "第四批",
    "superior": "",
    "type": "高职高专",
    "address": "",
    "location": ""
  },
  {
    "id": 123,
    "org_id": "",
    "name": "上海农林职业技术学院",
    "pc": "第四批",
    "superior": "",
    "type": "高职高专",
    "address": "",
    "location": ""
  },
  {
    "id": 124,
    "org_id": "",
    "name": "上海电子信息职业技术学院",
    "pc": "第四批",
    "superior": "",
    "type": "高职高专",
    "address": "",
    "location": ""
  },
  {
    "id": 125,
    "org_id": "4802",
    "name": "上海市建筑工程学校",
    "pc": "第四批",
    "superior": "闵行区",
    "type": "中职",
    "address": "上海市闵行区龙吴路4989号",
    "location": "31.062152,121.461269"
  },
  {
    "id": 126,
    "org_id": "1569",
    "name": "上海市曹杨职业技术学校",
    "pc": "第四批",
    "superior": "普陀区",
    "type": "中职",
    "address": "清涧路240号",
    "location": "31.263329,121.38533"
  },
  {
    "id": 127,
    "org_id": "",
    "name": "上海新闻出版职业技术学校",
    "pc": "第四批",
    "superior": "",
    "type": "中职",
    "address": "",
    "location": ""
  },
  {
    "id": 128,
    "org_id": "",
    "name": "上海市第二轻工业学校",
    "pc": "第四批",
    "superior": "",
    "type": "中职",
    "address": "",
    "location": ""
  },
  {
    "id": 129,
    "org_id": "651",
    "name": "上海市大众工业学校",
    "pc": "第四批",
    "superior": "嘉定区",
    "type": "中职",
    "address": "环城路2290号",
    "location": "31.384993,121.239779"
  },
  {
    "id": 130,
    "org_id": "",
    "name": "中华职业学校",
    "pc": "第四批",
    "superior": "",
    "type": "中职",
    "address": "",
    "location": ""
  },
  {
    "id": 131,
    "org_id": "133",
    "name": "上海大学附属中学",
    "pc": "第四批",
    "superior": "宝山区",
    "type": "高中",
    "address": "上大路688号",
    "location": "31.309664,121.391828"
  },
  {
    "id": 132,
    "org_id": "1222",
    "name": "上海市彭浦中学",
    "pc": "第四批",
    "superior": "静安区",
    "type": "高中",
    "address": "三泉路604号",
    "location": "31.312482,121.441771"
  },
  {
    "id": 133,
    "org_id": "787",
    "name": "上海市宜川中学",
    "pc": "第四批",
    "superior": "普陀区",
    "type": "高中",
    "address": "华阴路101号",
    "location": "31.261812,121.444875"
  },
  {
    "id": 134,
    "org_id": "",
    "name": "上海市向明中学",
    "pc": "第四批",
    "superior": "",
    "type": "高中",
    "address": "",
    "location": ""
  },
  {
    "id": 135,
    "org_id": "3437",
    "name": "上海市鲁迅中学",
    "pc": "第四批",
    "superior": "虹口区",
    "type": "高中",
    "address": "广中路132号",
    "location": "31.275363,121.477446"
  },
  {
    "id": 136,
    "org_id": "",
    "name": "上海师范大学第二附属中学",
    "pc": "第四批",
    "superior": "",
    "type": "高中",
    "address": "",
    "location": ""
  },
  {
    "id": 137,
    "org_id": "4283",
    "name": "复旦大学附属中学青浦分校",
    "pc": "第四批",
    "superior": "青浦区",
    "type": "高中",
    "address": "盘龙浦路500号",
    "location": "31.143037,121.078881"
  },
  {
    "id": 138,
    "org_id": "",
    "name": "上海市洋泾中学",
    "pc": "第四批",
    "superior": "",
    "type": "高中",
    "address": "",
    "location": ""
  },
  {
    "id": 139,
    "org_id": "",
    "name": "上海市闵行中学东校",
    "pc": "第四批",
    "superior": "",
    "type": "高中",
    "address": "",
    "location": ""
  },
  {
    "id": 140,
    "org_id": "248",
    "name": "上海市七宝中学（教育集团）",
    "pc": "第四批",
    "superior": "闵行区",
    "type": "高中",
    "address": "农南路22号",
    "location": "31.149369,121.366971"
  },
  {
    "id": 141,
    "org_id": "1385",
    "name": "上海市扬子中学",
    "pc": "第四批",
    "superior": "崇明区",
    "type": "高中",
    "address": "崇明县城桥镇北门路58号",
    "location": "31.627235,121.402592"
  },
  {
    "id": 142,
    "org_id": "317",
    "name": "上海市位育中学",
    "pc": "第四批",
    "superior": "徐汇区",
    "type": "高中",
    "address": "位育路1号",
    "location": "31.11985,121.443156"
  },
  {
    "id": 143,
    "org_id": "",
    "name": "上海市上南中学",
    "pc": "第四批",
    "superior": "",
    "type": "高中",
    "address": "",
    "location": ""
  },
  {
    "id": 144,
    "org_id": "",
    "name": "华东政法大学附属松江高级中学",
    "pc": "第四批",
    "superior": "",
    "type": "高中",
    "address": "",
    "location": ""
  },
  {
    "id": 145,
    "org_id": "1717",
    "name": "上海市杨浦高级中学",
    "pc": "第四批",
    "superior": "杨浦区",
    "type": "高中",
    "address": "四平路999号",
    "location": "31.277077,121.500433"
  },
  {
    "id": 146,
    "org_id": "1106",
    "name": "上海市崇明区民本中学",
    "pc": "第四批",
    "superior": "崇明区",
    "type": "高中",
    "address": "崇明县堡镇向阳路216号",
    "location": "31.533873,121.613561"
  },
  {
    "id": 147,
    "org_id": "1189",
    "name": "上海市市西中学",
    "pc": "第四批",
    "superior": "静安区",
    "type": "高中",
    "address": "愚园路404号",
    "location": "31.223387,121.44017"
  },
  {
    "id": 148,
    "org_id": "789",
    "name": "上海市宝山中学",
    "pc": "第四批",
    "superior": "宝山区",
    "type": "完中",
    "address": "盘古路247弄20号",
    "location": "31.412093,121.488516"
  },
  {
    "id": 149,
    "org_id": "1563",
    "name": "上海市曹杨中学",
    "pc": "第四批",
    "superior": "普陀区",
    "type": "完中",
    "address": "祁连山南路1069号",
    "location": "31.245001,121.367542"
  },
  {
    "id": 150,
    "org_id": "4412",
    "name": "上海市闵行区教育学院附属友爱实验中学",
    "pc": "第四批",
    "superior": "闵行区",
    "type": "完中",
    "address": "剑川路408号",
    "location": "31.038466,121.453847"
  },
  {
    "id": 151,
    "org_id": "",
    "name": "上海市甘泉外国语中学",
    "pc": "第四批",
    "superior": "",
    "type": "完中",
    "address": "",
    "location": ""
  },
  {
    "id": 152,
    "org_id": "4576",
    "name": "上海外国语大学附属外国语学校松江云间中学",
    "pc": "第四批",
    "superior": "松江区",
    "type": "完中",
    "address": "银泽路118弄1-23号",
    "location": "31.063804,121.246202"
  },
  {
    "id": 153,
    "org_id": "",
    "name": "上海市中国中学",
    "pc": "第四批",
    "superior": "",
    "type": "完中",
    "address": "",
    "location": ""
  },
  {
    "id": 154,
    "org_id": "1020",
    "name": "上海市实验学校附属东滩学校",
    "pc": "第四批",
    "superior": "崇明区",
    "type": "九年一贯制",
    "address": "陈家镇雪雁路800号",
    "location": "31.490391,121.807607"
  },
  {
    "id": 155,
    "org_id": "1018",
    "name": "上海市实验学校东校",
    "pc": "第四批",
    "superior": "浦东新区",
    "type": "九年一贯制",
    "address": "黑松路251号",
    "location": "31.233095,121.573915"
  },
  {
    "id": 156,
    "org_id": "2773",
    "name": "上海市行知中学附属宝山实验学校",
    "pc": "第四批",
    "superior": "宝山区",
    "type": "九年一贯制",
    "address": "锦秋路3000号",
    "location": "31.318092,121.352843"
  },
  {
    "id": 157,
    "org_id": "1784",
    "name": "上海市松江区民乐学校",
    "pc": "第四批",
    "superior": "松江区",
    "type": "九年一贯制",
    "address": "人民北路439号",
    "location": "31.018983,121.224713"
  },
  {
    "id": 158,
    "org_id": "767",
    "name": "上海市奉贤区阳光外国语学校",
    "pc": "第四批",
    "superior": "奉贤区",
    "type": "九年一贯制",
    "address": "南桥镇环城西路69号",
    "location": "30.902542,121.445401"
  },
  {
    "id": 159,
    "org_id": "4233",
    "name": "华东师范大学第四附属中学",
    "pc": "第四批",
    "superior": "普陀区",
    "type": "九年一贯制",
    "address": "泸定路279号",
    "location": "31.224779,121.386057"
  },
  {
    "id": 160,
    "org_id": "4219",
    "name": "中科院上海实验学校",
    "pc": "第四批",
    "superior": "嘉定区",
    "type": "九年一贯制",
    "address": "菊园新区竹筱路33号",
    "location": "31.379755,121.232441"
  },
  {
    "id": 161,
    "org_id": "3119",
    "name": "上海交通大学附属闵行马桥实验学校",
    "pc": "第四批",
    "superior": "闵行区",
    "type": "九年一贯制",
    "address": "银春路1750号",
    "location": "31.02849,121.395616"
  },
  {
    "id": 162,
    "org_id": "",
    "name": "上海师范大学附属第五嘉定实验学校",
    "pc": "第四批",
    "superior": "",
    "type": "九年一贯制",
    "address": "",
    "location": ""
  },
  {
    "id": 163,
    "org_id": "3187",
    "name": "上海市青浦区崧泽学校",
    "pc": "第四批",
    "superior": "青浦区",
    "type": "九年一贯制",
    "address": "赵巷镇赵华路58号",
    "location": "31.154037,121.205648"
  },
  {
    "id": 164,
    "org_id": "1847",
    "name": "上海市毓秀学校",
    "pc": "第四批",
    "superior": "青浦区",
    "type": "九年一贯制",
    "address": "崧文路333号",
    "location": "31.164061,121.156338"
  },
  {
    "id": 165,
    "org_id": "",
    "name": "上海市市西初级中学",
    "pc": "第四批",
    "superior": "",
    "type": "初中",
    "address": "",
    "location": ""
  },
  {
    "id": 166,
    "org_id": "",
    "name": "上海市建平实验张江中学",
    "pc": "第四批",
    "superior": "",
    "type": "初中",
    "address": "",
    "location": ""
  },
  {
    "id": 167,
    "org_id": "3177",
    "name": "上海市青浦区实验中学",
    "pc": "第四批",
    "superior": "青浦区",
    "type": "初中",
    "address": "青赵公路1118号",
    "location": "31.14979,121.09659"
  },
  {
    "id": 168,
    "org_id": "890",
    "name": "上海市宝山区求真中学",
    "pc": "第四批",
    "superior": "宝山区",
    "type": "初中",
    "address": "通河一村5号",
    "location": "31.336861,121.450383"
  },
  {
    "id": 169,
    "org_id": "",
    "name": "上海市娄山中学",
    "pc": "第四批",
    "superior": "",
    "type": "初中",
    "address": "",
    "location": ""
  },
  {
    "id": 170,
    "org_id": "",
    "name": "上海市西延安中学",
    "pc": "第四批",
    "superior": "",
    "type": "初中",
    "address": "",
    "location": ""
  },
  {
    "id": 171,
    "org_id": "7600",
    "name": "上海市卢湾中学",
    "pc": "第四批",
    "superior": "黄浦区",
    "type": "初中",
    "address": "上海市黄浦区斜土路855号",
    "location": "31.202048,121.470256"
  },
  {
    "id": 172,
    "org_id": "2894",
    "name": "上海市金山实验中学",
    "pc": "第四批",
    "superior": "金山区",
    "type": "初中",
    "address": "石化卫新路115号",
    "location": "30.695322,121.286004"
  },
  {
    "id": 173,
    "org_id": "1214",
    "name": "上海市建平实验中学",
    "pc": "第四批",
    "superior": "浦东新区",
    "type": "初中",
    "address": "枣庄路111号",
    "location": "31.259666,121.57158"
  },
  {
    "id": 174,
    "org_id": "656",
    "name": "上海市大同初级中学",
    "pc": "第四批",
    "superior": "黄浦区",
    "type": "初中",
    "address": "瞿溪路202号",
    "location": "31.204892,121.492971"
  },
  {
    "id": 175,
    "org_id": "",
    "name": "上海市三门中学（上海财经大学附属初级中学）",
    "pc": "第四批",
    "superior": "",
    "type": "初中",
    "address": "",
    "location": ""
  },
  {
    "id": 176,
    "org_id": "304",
    "name": "上海市临港第一中学",
    "pc": "第四批",
    "superior": "浦东新区",
    "type": "初中",
    "address": "马樱丹路116号",
    "location": "30.883816,121.919558"
  },
  {
    "id": 177,
    "org_id": "941",
    "name": "上海市宝山区美兰湖中学",
    "pc": "第四批",
    "superior": "宝山区",
    "type": "初中",
    "address": "罗店镇美诺路150号",
    "location": "31.405948,121.359726"
  },
  {
    "id": 178,
    "org_id": "",
    "name": "上海市蒙山中学",
    "pc": "第四批",
    "superior": "",
    "type": "初中",
    "address": "",
    "location": ""
  },
  {
    "id": 179,
    "org_id": "2904",
    "name": "上海市钟山初级中学",
    "pc": "第四批",
    "superior": "虹口区",
    "type": "初中",
    "address": "万安路1289号",
    "location": "31.301493,121.466678"
  },
  {
    "id": 180,
    "org_id": "640",
    "name": "上海市复兴实验中学",
    "pc": "第四批",
    "superior": "虹口区",
    "type": "初中",
    "address": "汶水东路690弄73号",
    "location": "31.288956,121.474645"
  },
  {
    "id": 181,
    "org_id": "4273",
    "name": "同济大学附属实验中学",
    "pc": "第四批",
    "superior": "嘉定区",
    "type": "初中",
    "address": "安亭镇荣泽路108号",
    "location": "31.279004,121.162726"
  },
  {
    "id": 182,
    "org_id": "",
    "name": "上海市浦东新区洋泾实验小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 183,
    "org_id": "3059",
    "name": "上海市闵行区浦汇小学",
    "pc": "第四批",
    "superior": "闵行区",
    "type": "小学",
    "address": "浦江镇盐铁塘路281号",
    "location": "31.034818,121.508295"
  },
  {
    "id": 184,
    "org_id": "",
    "name": "上海市普陀区新普陀小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 185,
    "org_id": "",
    "name": "上海师范大学附属卢湾实验小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 186,
    "org_id": "2966",
    "name": "上海市长宁区绿苑小学",
    "pc": "第四批",
    "superior": "长宁区",
    "type": "小学",
    "address": "甘溪路340号",
    "location": "31.211788,121.360997"
  },
  {
    "id": 187,
    "org_id": "",
    "name": "上海市闸北田家炳小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 188,
    "org_id": "2872",
    "name": "上海市金山区第一实验小学",
    "pc": "第四批",
    "superior": "金山区",
    "type": "小学",
    "address": "朱泾镇众安街225号",
    "location": "30.888433,121.175641"
  },
  {
    "id": 189,
    "org_id": "2702",
    "name": "上海市虹口区外国语第一小学",
    "pc": "第四批",
    "superior": "虹口区",
    "type": "小学",
    "address": "车站南路441号",
    "location": "31.294418,121.4727"
  },
  {
    "id": 190,
    "org_id": "2734",
    "name": "上海市虹口区曲阳第四小学",
    "pc": "第四批",
    "superior": "虹口区",
    "type": "小学",
    "address": "密云路471弄1号",
    "location": "31.283296,121.495673"
  },
  {
    "id": 191,
    "org_id": "2611",
    "name": "上海市第二师范学校附属小学",
    "pc": "第四批",
    "superior": "杨浦区",
    "type": "小学",
    "address": "大连西路16号",
    "location": "31.276836,121.499518"
  },
  {
    "id": 192,
    "org_id": "",
    "name": "上海市奉贤区教育学院附属实验小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 193,
    "org_id": "2749",
    "name": "上海市虹口区第二中心小学",
    "pc": "第四批",
    "superior": "虹口区",
    "type": "小学",
    "address": "海拉尔路303号",
    "location": "31.259318,121.496005"
  },
  {
    "id": 194,
    "org_id": "1735",
    "name": "上海市松江区九亭第五小学",
    "pc": "第四批",
    "superior": "松江区",
    "type": "小学",
    "address": "涞亭南路1850号",
    "location": "31.115235,121.343506"
  },
  {
    "id": 195,
    "org_id": "",
    "name": "上海市浦东新区福山外国语小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 196,
    "org_id": "",
    "name": "上海市奉贤区南桥小学（上海市奉贤区恒贤小学）",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 197,
    "org_id": "",
    "name": "上海市黄浦区蓬莱路第二小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 198,
    "org_id": "3268",
    "name": "上海市青浦瀚文小学",
    "pc": "第四批",
    "superior": "青浦区",
    "type": "小学",
    "address": "卫中路1号",
    "location": "31.150805,121.107763"
  },
  {
    "id": 199,
    "org_id": "",
    "name": "上海市宝山区第一中心小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 200,
    "org_id": "",
    "name": "上海市金山区第二实验小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 201,
    "org_id": "",
    "name": "上海市杨浦区平凉路第三小学",
    "pc": "第四批",
    "superior": "",
    "type": "小学",
    "address": "",
    "location": ""
  },
  {
    "id": 202,
    "org_id": "",
    "name": "上海市杨浦区翔殷幼稚园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 203,
    "org_id": "",
    "name": "上海市长宁实验幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 204,
    "org_id": "",
    "name": "上海市浦东新区东南幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 205,
    "org_id": "",
    "name": "上海市静安区威海路幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 206,
    "org_id": "",
    "name": "上海市奉贤区江海幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 207,
    "org_id": "",
    "name": "上海市黄浦区瑞金一路幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 208,
    "org_id": "",
    "name": "上海市嘉定区朱桥幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 209,
    "org_id": "",
    "name": "上海市徐汇区机关建国幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 210,
    "org_id": "",
    "name": "上海市松江区大学城幼儿园",
    "pc": "第四批",
    "superior": "",
    "type": "幼儿园",
    "address": "",
    "location": ""
  },
  {
    "id": 211,
    "org_id": "3204",
    "name": "上海市青浦区御澜湾幼儿园",
    "pc": "第四批",
    "superior": "青浦区",
    "type": "幼儿园",
    "address": "盈绿路30号",
    "location": "31.139031,121.095852"
  },
  {
    "id": 212,
    "org_id": "4251",
    "name": "华东师范大学附属紫竹幼儿园",
    "pc": "第四批",
    "superior": "闵行区",
    "type": "幼儿园",
    "address": "紫龙路585号",
    "location": "31.032443,121.465076"
  }];*/
 // const test ="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" 
  //const test1 = this.util.encryptData(JSON.stringify(test));
      // const test1 = this.util.daeacarayapata(test);
    //   console.log('test1', test1);
       //console.log('test1',  JSON.stringify(test1));
      // console.log('test2', test2, JSON.stringify(test2) === JSON.stringify(test));
      // console.log('ngOnInit', rows);
      const types = [];
      for (const row of rows) {
        if (types.includes(row.type)) { continue; }

        types.push(row.type);
      }
      this.types = types;
      this.getRows();
    });
  }

  preProf() {
    this.typei -= 1;
    if (this.typei === -1) { this.typei = this.types.length - 1; }

    this.getRows();
  }

  nextProf() {
    this.typei += 1;
    if (this.typei === this.types.length) { this.typei = 0; }

    this.getRows();
  }
  getRows() {
    const rows = [];
    for (let i = 0; i < this.data.length; i++) {
      const row = this.data[i];
      if (this.types[this.typei] === row.type) { rows.push(row); }
    }
    this.rows = rows;
  }
  toView(i: number = -1) {
   /* if (i != -1 && this.util.isMiniProgram()){
      for (let xi = 0; xi < this.rows.length; xi++) {
        if (this.rows[xi].id == i ){
          const xurl = '/pages/index/search/view/view?id=' + this.rows[xi].org_id;
          window.parent.postMessage(`poi:${xurl}`, '*'); // 后面的*号就是处理跨域问题的
          window.wx.miniProgram.navigateTo({
            url: xurl,
          });
          return;
        }
      }
    } */
    for (let xi = 0; xi < this.rows.length; xi++) {
        if (this.rows[xi].id == i ){
          if(this.rows[xi].location!="")
            this.router.navigateByUrl('/new/pmap/science_rgzn/' + i);
          return;
        }
      }
    console.log(i);
  }
}
